import {
  TariffSummaryAlertConfiguration,
  TariffSummaryConsumptionLevel,
} from '../models/tariffSummaryModels';

export const PRODUCT_TYPE = {
  SIM: 'Sim',
  RSIM: 'Rsim',
} as const;

export type TariffSummaryEntryDTO = {
  bundleProductCode: string;
  tariffDescription: string | null;
  alertConfiguration: TariffSummaryAlertConfiguration | null;
  activeCount: number | null;
  data: {
    used: number | null;
    forecast: number | null;
    allowance: number | null;
    consumptionLevelUsed: TariffSummaryConsumptionLevel | null;
    consumptionLevelForecast: TariffSummaryConsumptionLevel | null;
  };
  sms: {
    sent: number | null;
    forecast: number | null;
    allowance: number | null;
    consumptionLevelSent: TariffSummaryConsumptionLevel | null;
    consumptionLevelForecast: TariffSummaryConsumptionLevel | null;
  };
  voice: {
    usedSeconds: number | null;
    forecastSeconds: number | null;
    allowanceSeconds: number | null;
    consumptionLevelUsed: TariffSummaryConsumptionLevel | null;
    consumptionLevelForecast: TariffSummaryConsumptionLevel | null;
  };
  productType: string;
  productCodes: string[];
};

export type TariffSummaryListDTO = {
  totalProducts: number;
  page: number;
  pageSize: number;
  products: TariffSummaryEntryDTO[];
};
